import { TbFileCv } from "react-icons/tb";
import cv from "../../files/CV_Alisa Moldavanova_06_2025.pdf";

export const CV = () => {
	return (
		<section className="container">
			<div className="cv__content">
				<div className="cv__icon">
					<a
						href={cv}
						target="_blank"
						download
						rel="noopener noreferrer"
					>
						<TbFileCv />
					</a>
				</div>
				<div>
					<p className="cv__text">
						Alisa Moldavanova is a scholar specializing in
						organizational sustainability, focusing on public
						service and nonprofit organizations and their roles in
						fostering sustainable communities, as well as
						researching on the role of civil society and nonprofit
						sector organizations in advancing democracy. She is the
						author of two books, including the{" "}
						<i>
							Overlooked Pillar: Making a Case for Cultural
							Sustainability
						</i>{" "}
						(2024, SUNY Press), and the 2018 co-edited volume,{" "}
						<i>
							The Nonprofit Sector in Eastern Europe, Russia, and
							Central Asia: Civil Society Advances and Challenges
						</i>
						, an inaugural book in the nonprofit research series by
						Brill Publishers.{" "}
					</p>
					<p className="cv__text">
						She currently serves on the Board of Directors of the
						Association for Research on Nonprofit Organizations and
						Voluntary Action (ARNOVA) and is the immediate past
						chair of the Section on Public Administration Research
						(American Society for Public Administration). From 2021
						to 2023, she served on the Leadership Council of the
						Nonprofit Management Education Section of the Network of
						Schools of Public Policy, Affairs, and Administration
						(NASPAA). Before joining the University of Delaware in
						2022, Moldavanova was an Associate Professor of Public
						Administration and Nonprofit Management and Coordinator
						of the Graduate Certificate in Nonprofit Management in
						the Department of Political Science at Wayne State
						University (Detroit, Michigan).​
					</p>
				</div>
			</div>
		</section>
	);
};
